import { Fragment, useEffect, useId, useLayoutEffect, useRef, useState } from "react";
import { Box, Button, Card, CardContent, Checkbox, Collapse, Divider, FormControl, IconButton, Input, InputAdornment, List, ListItem, ListItemButton, ListItemText, MenuItem, Modal, Paper, Popover, Select, Switch, TextField, Typography } from "@mui/material";
import { modal_style } from "styles/modal_style"
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { colors } from "styles/colors";
import Carousel from "react-material-ui-carousel";
import FileUploadIcon from '@mui/icons-material/FileUpload';
import DeleteIcon from '@mui/icons-material/Delete';
import { useSelector } from "react-redux";
import { loginSelector } from "store/slices/loginSlice";
import { get } from "api/apiBridges/httpBridge";
import Loading from 'components/Load';
import { AnimatedGallery } from "react-animated-gallery";
import NoSelect from "../../images/others/NoSelect.png"
import { buttonColorHover, hoverStyle } from "styles/main";
import usePreventDoubleClick from "components/AntiDBC";

export function TextInput({ title, val, onChange, adornment = undefined, editable = true}) {
  let [$text, $setchecked] = useState(val);

  const change = (text) => {
    if (!editable) return; // Запрещаем изменение, если editable = false

    $text = text;
    $setchecked(JSON.parse(JSON.stringify($text)));
    if (onChange) { onChange($text) }
  }


  return (
    <TextField
      label={title}
      value={val}
      variant="standard"
      onChange={(event) => change(event.target.value)}
      InputProps={{
        endAdornment: adornment ? (
          <InputAdornment position="end">
            {adornment}
          </InputAdornment>
        ) : null,
        readOnly: !editable, // Делаем поле только для чтения
      }}

    />
  )
}

export function StyledTextInput({ title, val, onChange, adornment = undefined, editable = true}) {
  let [$text, $setchecked] = useState(val);

  const change = (text) => {
    if (!editable) return; // Запрещаем изменение, если editable = false

    $text = text;
    $setchecked(JSON.parse(JSON.stringify($text)));
    if (onChange) { onChange($text) }
  }


  return (
    <div style={{display: 'flex', flexDirection: "row", alignItems: "center"}}>
      <Typography 
        sx={{
          marginRight: '5px',
          fontWeight: 'bold',
          alignSelf: 'center'
        }}
      >
        {title}:
      </Typography>
      <TextField
        label={undefined}
        value={val}
        variant="standard"
        onChange={(event) => change(event.target.value)}
        InputProps={{
          endAdornment: adornment ? (
            <InputAdornment position="end">
              {adornment}
            </InputAdornment>
          ) : null,
          readOnly: !editable, // Делаем поле только для чтения
        }}
        sx={{
          '& .MuiInput-root': {
            paddingTop: '1px'
          },
          '& .MuiInputBase-input': {
            alignSelf: 'center' // Выравниваем текст по центру вертикали
          },
          '& .MuiInput-underline': {
            '&:before': {
              borderBottom: 'none',
            },
            '&:hover:not(.Mui-disabled):before': {
              borderBottom: 'none',
            },
          },
        }}

      />
    </div>
  )
}


export function NumInput({ title, val, onChange, adornment = undefined, editable = true}) {
  const [count, setCount] = useState(val || 0);

  
  useEffect(() => {
      if (val) {
        let tmp = parseInt(val, 10)
        if (!isNaN(tmp)) {
            setCount(tmp);
            onChange(tmp);
        }
        else {
          setCount(0)
        }
      }
  }, [val]);

  const handleInputChange = (value) => {
      if (value === '') {
          setCount(0);
          onChange(0);
      }
      else {
          let tmp = parseInt(value, 10)
          if (!isNaN(tmp)) {
              setCount(tmp);
              onChange(tmp);
          }
      }
  };


  return (
    <TextField
      label={title}
      value={count}
      variant="standard"
      onChange={(event) => handleInputChange(event.target.value)}
      InputProps={{
        endAdornment: adornment ? (
          <InputAdornment position="end">
            {adornment}
          </InputAdornment>
        ) : null,
        readOnly: !editable, // Делаем поле только для чтения
      }}

    />
  )
}



export function TextNumInput({ title, val, onChange, adornment = undefined, editable = true, maxCount=30}) {
  const [count, setCount] = useState(val || '');

    useEffect(() => {
        if (val) setCount(val)
    }, [val]);

    const handleInputChange = (value) => {
        if (value === '') {
            setCount('');
            onChange('');
        }
        else {
            if (/^\d+$/.test(value) && value.length <= maxCount) {
              setCount(value);
              onChange(value);
            }
        }
    };


  return (
    <TextField
      label={title}
      value={count}
      variant="standard"
      onChange={(event) => handleInputChange(event.target.value)}
      InputProps={{
        endAdornment: adornment ? (
          <InputAdornment position="end">
            {adornment}
          </InputAdornment>
        ) : null,
        readOnly: !editable, // Делаем поле только для чтения
      }}

    />
  )
}

export function TextFeature({ title, val }) {

  return (
    // <div>
    //   <Typography variant="h4">{title}: {val}</Typography>
    // </div>
    <TextField
      label={title}
      value={val}
      variant="standard"
      InputProps={{ readOnly: true }}
    />
  )
}

//КОМПОНЕНТЫ ДЛЯ ДИЗАЙНА
export function TextFeatureDesign({ title, val, marginLeft = '10px' }) {

  return (
    <Box display="flex" flexDirection="row" alignItems="center" justifyContent="space-between">
      <Typography style={{ color: "#555", fontWeight: 500, fontSize: "14pt", minWidth: '160px' }}>
        {title}
      </Typography>
      <Typography style={{  color: "#838383", fontWeight: 500, fontSize: "15pt", flex: 1 , marginLeft:marginLeft }}>
        {val}
      </Typography>
    </Box>
  )
}

 export function TextInputDesign({title, val, onChange=() => {}, adornment = undefined, editable = true, marginLeft = '10px', fontSize = '12pt', adaptive = false, align='left', colorTitle='#300342f', colorValue="black", maxLength = 0}){

  let [text, setText] = useState(val);
  const [focused, setFocused] = useState(false);
  // Проверка, установлено ли значение (пустая строка, null, undefined)
  const isEmpty = text === '' || text === null || text === undefined;
  // Показывать линию, если значение не установлено ИЛИ поле в фокусе
  const showUnderline = editable && (isEmpty || focused)

  const { fontSize: adaptiveFontSize, ref: containerRef } = useAdaptiveFontSize({
    min: 10,
    max: 28,
    ratio: 0.045,
  });
  const finalFontSize = adaptive ? adaptiveFontSize : fontSize

  useEffect(() => {
    if (val) {
      setText(val)
    }
  }, [val]);

  const change = ($text) => {
    if (!editable) return; // Запрещаем изменение, если editable = false
    if (maxLength !== 0 && $text.length > maxLength) {return;}
    setText($text)
    if (onChange) { onChange($text) }
  }
  
  return(
    <Box 
      ref={adaptive ? containerRef : undefined} 
      sx={{
        width: "100%", 
        display: "flex", 
        flexDirection: "row", 
        alignItems: "flex-start", 
        justifyContent: "space-between"
        }}
      >
      <Typography style={{ color: colorTitle, fontSize, }}>
        {title}
      </Typography>
      <Box flex={1} marginLeft={marginLeft}>
        <TextField
          sx={{
            width: "100%",
            fontSize:finalFontSize,
            lineHeight: finalFontSize,
            // Убираем нижний отступ, который создаёт расстояние до линии
            '& .MuiInput-root': {
              marginBottom: 0,
              '&:before, &:after': {
                bottom: 0, // линия прижата к низу контейнера ввода
              },
            },
            // Убираем padding-bottom у input, чтобы текст был ближе к линии
            '& .MuiInput-input': {
              paddingBottom: 0,
              paddingTop: 0,
              marginBottom: 0,
              marginTop: 0,
              lineHeight: 1.5, 
              textAlign: align,
              color: colorValue,
            },
            '& .MuiInput-underline:before': {
              borderBottomColor: showUnderline ? '#838383' : 'transparent',
            },
            '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
              borderBottomColor: showUnderline ? '#838383' : 'transparent',
            },
            '& .MuiInput-underline:after': {
              borderBottomColor: showUnderline ? '#444' : 'transparent',
            },
          }}
          label={undefined}
          value={text}
          variant="standard"
          autoComplete="off"
          onChange={(event) => change(event.target.value)}
          onFocus={() => setFocused(true)}
          onBlur={() => setFocused(false)}
          InputProps={{
            endAdornment: adornment ? (
              <InputAdornment position="end">{adornment}</InputAdornment>
            ) : null,
            readOnly: !editable,
          }}
        />
      </Box>
    </Box>
  )
 }

  export function useAdaptiveFontSize({ min = 10, max = 45, ratio = 0.045 } = {}) {
    const [fontSize, setFontSize] = useState(min);
    const elementRef = useRef(null);

    useEffect(() => {
      const element = elementRef.current;
      if (!element) return;

      const parent = element.parentElement;
      if (!parent) return;

      const updateFontSize = (width) => {
        let newSize = width * ratio;
        newSize = Math.min(max, Math.max(min, newSize));
        setFontSize(newSize);
      };

      const resizeObserver = new ResizeObserver((entries) => {
        const width = entries[0].contentRect.width;
        updateFontSize(width);
      });

      resizeObserver.observe(parent);
      // Начальный вызов
      updateFontSize(parent.clientWidth);

      return () => resizeObserver.disconnect();
    }, [ratio, min, max]);

    return { fontSize: `${fontSize}px`, ref: elementRef };
  }

 export function NumInputDesign({ title, val, onChange=() => {}, adornment = undefined, editable = true, marginLeft = '10px', fontSize = '12pt',adaptive = false, align='left', colorTitle='#300342f', colorValue="black", float = false}) {
  const [count, setCount] = useState(val || 0);
  const [focused, setFocused] = useState(false);
  // Проверка, установлено ли значение (пустая строка, null, undefined)
  const isEmpty = count === '' || count === null || count === undefined;
  // Показывать линию, если значение не установлено ИЛИ поле в фокусе
  const showUnderline = editable && (isEmpty || focused)

  const { fontSize: adaptiveFontSize, ref: containerRef } = useAdaptiveFontSize({
    min: 10,
    max: 28,
    ratio: 0.045,
  });
  const finalFontSize = adaptive ? adaptiveFontSize : fontSize
  
  useEffect(() => {
    if (float) {
      if (val) {
        let tmp = parseFloat(val)
        if (!isNaN(tmp)) {
            setCount(tmp);
            onChange(tmp);
        }
        else {
          setCount(0)
        }
      }
    }
    else {
      if (val) {
        let tmp = parseInt(val, 10)
        if (!isNaN(tmp)) {
            setCount(tmp);
            onChange(tmp);
        }
        else {
          setCount(0)
        }
      }
    }
  }, [val]);

  const handleInputChange = (value) => {
      if (value === '') {
          setCount(0);
          onChange(0);
      }
      else {
        if (float) {
          let tmp = undefined
          if (value[value.length -1] === '.') {
            setCount(value);
          }
          else {
            tmp = parseFloat(value)
            if (!isNaN(tmp)) {
              setCount(tmp);
              onChange(tmp);
            }
          }
        }
        else {
          let tmp = parseInt(value, 10)
          if (!isNaN(tmp)) {
              setCount(tmp);
              onChange(tmp);
          }
        }
      }
  };

  return (
    <Box 
      ref={adaptive ? containerRef : undefined} 
      sx={{
        width: "100%", 
        display: "flex", 
        flexDirection: "row", 
        alignItems: "flex-start", 
        justifyContent: "space-between"
        }}
    >
      <Typography style={{ color: colorTitle, fontWeight: 500, fontSize, }}>
        {title}:
      </Typography>
      <Box flex={1} marginLeft={marginLeft}>
        <TextField
          sx={{
            width: '100%',
            fontSize:finalFontSize,
            lineHeight: finalFontSize,
            textAlign:align,
            // Убираем нижний отступ, который создаёт расстояние до линии
            '& .MuiInput-root': {
              marginBottom: 0,
              '&:before, &:after': {
                bottom: 0, // линия прижата к низу контейнера ввода
              },
            },
            // Убираем padding-bottom у input, чтобы текст был ближе к линии
            '& .MuiInput-input': {
              paddingBottom: 0,
              paddingTop: 0,
              marginBottom: 0,
              marginTop: 0,
              lineHeight: 1.5, 
              textAlign: align,
              color: colorValue,
            },
            '& .MuiInput-underline:before': {
              borderBottomColor: showUnderline ? '#838383' : 'transparent',
            },
            '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
              borderBottomColor: showUnderline ? '#838383' : 'transparent',
            },
            '& .MuiInput-underline:after': {
              borderBottomColor: showUnderline ? '#444' : 'transparent',
            },
          }}
          label={undefined}
          value={count}
          variant="standard"
          autoComplete="off"
          onChange={(event) => handleInputChange(event.target.value)}
          onFocus={() => setFocused(true)}
          onBlur={() => setFocused(false)}
          InputProps={{
            endAdornment: adornment ? (
              <InputAdornment position="end">{adornment}</InputAdornment>
            ) : null,
            readOnly: !editable,
          }}
        />
      </Box>
    </Box>
  );
}


export function TextFeatureBig({ title, val }) {

  return (
    <div>
      <Typography variant="h4">{title}:</Typography>
      <Typography variant="h1">
        {val}
      </Typography>
    </div>
  )
}

export function ImagesCorusel({items, onChangeList, editable=true, onDel}) {
  // 1. Инициализируем индекс длиной массива (чтобы при первой загрузке тоже мог быть конец, если надо)
  const [selectedPage, setSelectedPage] = useState(0);

  // Синхронизируем индекс при изменении items
  useEffect(() => {
    if (items && items.length > 0) {
      // Устанавливаем индекс на самый последний элемент
      setSelectedPage(items.length - 1);
    }
  }, [items.length]); // Следим именно за изменением количества элементов

  const delImage = async () => {
    if (onDel) onDel(selectedPage)
  }

  const id = useId();

  return (
    <Card sx={{ borderRadius: 3, boxShadow: 5, marginTop: "15px", width: '100%' }}>
      <CardContent sx={{ p: "15px 0px 0px 15px", height: '100%', display: 'flex', flexDirection: 'row'}}>
        <div style={{ flex: 1, position: 'relative', height: '100%' }}>
          {items.length > 0 ? (
            <Carousel 
              index={selectedPage} 
              autoPlay={false}
              indicators={true}
              onChange={(now) => setSelectedPage(now)}
              indicatorContainerProps={{
                style: {
                  position: 'absolute',
                  bottom: '10px',
                  left: 0,
                  right: 0,
                  zIndex: 2,
                  display: 'flex',
                  justifyContent: 'center'
                }
              }}
              indicatorIconButtonProps={{
                style: {
                  color: 'gray',
                  margin: '0 2px',
                  padding: '2px'
                }
              }}
              activeIndicatorIconButtonProps={{
                style: {
                  color: '#078376'
                }
              }}
              sx={{ 
                width: '100%', 
                height: '100%',
                aspectRatio: '1 / 1',
                // Принудительно задаём высоту для всех внутренних контейнеров карусели
                '& .Carousel-slide': { height: '100%' },
                '& .Carousel-slide > div': { height: '100%' },
                '& .Carousel-item': { height: '100%' }
              }}
            >
              {items.map((image, i) => (
                <Paper key={i} elevation={5} sx={{ 
                  height: '100%', 
                  display: 'flex', 
                  alignItems: 'center', 
                  justifyContent: 'center',
                  p: 0,          // убираем внутренние отступы
                  borderRadius: 0 // убираем скругление, чтобы не мешало
                }}>
                  <Box
                    component="img"
                    sx={{ 
                      maxWidth: '100%', 
                      maxHeight: '100%', 
                      objectFit: 'contain',
                      display: 'block'
                    }}
                    src={image.src}
                    alt={`Slide ${i}`}
                  />
                </Paper>
              ))}
            </Carousel>
          ) : (
            <Paper elevation={5} sx={{ 
              height: '100%', 
              display: 'flex', 
              alignItems: 'center', 
              justifyContent: 'center',
              p: 0,
              borderRadius: 0
            }}>
              <Box
                component="img"
                sx={{ 
                  maxWidth: '100%', 
                  maxHeight: '100%', 
                  objectFit: 'contain',
                  display: 'block'
                }}
                src={NoSelect}                
              />
            </Paper>
          )}
        </div>

        {editable && (
          <div style={{ 
            display: "flex", 
            flexDirection: "column", 
            alignItems: 'center', 
            justifyContent: 'center', 
            padding: '0 8px' 
          }}>
            <IconButton aria-label="delImage" onClick={delImage} sx={{ width: 40, height: 40 }}>
              <DeleteIcon sx={{ transition: 'all 0.3s ease', '&:hover': hoverStyle }} />
            </IconButton>
            <IconButton sx={{ width: 40, height: 40 }}>
              <input
                type="file"
                multiple
                accept="application/png"
                style={{ display: "none" }}
                id={`${id}-full`}
                onChange={onChangeList}
              />
              <label htmlFor={`${id}-full`}>
                <FileUploadIcon sx={{ transition: 'all 0.3s ease', '&:hover': hoverStyle, marginTop: "10px" }} />
              </label>
            </IconButton>
          </div>
        )}
      </CardContent>
    </Card>

  )  
}



export function CheckList({title, varlist, selected, onChange}) {
  let [open, setOpen] = useState(false);
  let [$data, $setData] = useState(selected)
  
  const ListHandleClick = () => {
    setOpen(JSON.parse(JSON.stringify(!open)));
  };

  const HandleClick = async (index) => {
    let idx = $data.findIndex((el) => el === varlist[index].id);
    if (idx >-1) {$data.splice(idx,1)}
    else {$data.push(varlist[index].id)}
    $setData(JSON.parse(JSON.stringify($data)));
    onChange($data)
  }

  return (
    <>
    <ListItemButton onClick={() => ListHandleClick()}>
      <ListItemText primary={title} />
      {open ? <ExpandLess /> : <ExpandMore />}
    </ListItemButton>  

    <Collapse in={open} timeout="auto" unmountOnExit>
      <List component="div" disablePadding  style={{display:"flex", flexDirection:'column'}}>
        {
          varlist.map((el, index) => (
            <div style={{margin: "5px", display:"flex", flexDirection:'row', alignItems:"center", borderRadius:'10px', backgroundColor:"#cfcfd4"}}> 
              <Switch
                color="primary"
                checked={$data.includes(el.id)}
                onClick={() => HandleClick(index)}
              />
              {el.title}
            </div>
          ))
        }
      </List>
    </Collapse>

    </>  
  )
}

export function DropdownMenu({ data, onChange, startVal, defText }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [activeItem, setActiveItem] = useState(null);
  const [subMenuOpen, setSubMenuOpen] = useState(false);
  const timeoutRef = useRef(null);
  const menuContainerRef = useRef(null);
  const [selected, setSelected] = useState(undefined);

  const mainMenuPaperRef = useRef(null);
  const savedScrollTop = useRef(0);

  const handleClick = (event) => {
    if (anchorEl) {
      handleClose();
    } else {
      setAnchorEl(event.currentTarget);
    }
  };

  const handleClose = () => {
    setAnchorEl(null);
    setActiveItem(null);
    setSubMenuOpen(false);
  };

  const handleItemClick = (item) => {
    if (item.items && item.items.length > 0) {
      setActiveItem(item);
      setSubMenuOpen(true);
    }
    else {
      setActiveItem(null);
      setSubMenuOpen(false);
    }
  };

  const handleMouseLeaveMenu = () => {
    // Можно оставить пустым или закомментировать, чтобы меню не закрывалось при уходе мыши
  };

  const handleMouseEnterMenu = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
  };

  const handleSubItemClick = (subItem) => {
    console.log('Выбран подэлемент:', subItem);
    setSelected(subItem.name);
    onChange(subItem.name);
    handleClose(); // Для подменю закрываем меню (или можно оставить открытым, если нужно)
  };

  useEffect(() => {
    setSelected(startVal);
  }, [startVal]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuContainerRef.current && !menuContainerRef.current.contains(event.target)) {
        handleClose();
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, []);

  const handleMainMenuScroll = (e) => {
    savedScrollTop.current = e.target.scrollTop;
  };

  useLayoutEffect(() => {
    if (mainMenuPaperRef.current) {
      mainMenuPaperRef.current.scrollTop = savedScrollTop.current;
    }
  }, [subMenuOpen, activeItem]);

  const CombinedMenu = () => (
    <Box
      ref={menuContainerRef}
      onMouseLeave={handleMouseLeaveMenu}
      onMouseEnter={handleMouseEnterMenu}
      sx={{
        display: 'flex',
        position: 'relative',
        backgroundColor: 'white',
        borderRadius: '8px',
        boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
        overflow: 'visible',
      }}
    >
      <Paper
        ref={mainMenuPaperRef}
        onScroll={handleMainMenuScroll}
        sx={{
          borderRadius: '8px 0 0 8px',
          borderRight: '1px solid #f0f0f0',
          minWidth: '200px',
          overflow: 'auto',
          height: '265px',
        }}
      >
        <List dense sx={{ py: 0 }}>
          {data.map((item) => (
            <Fragment key={item.id}>
              <ListItem
                button
                data-item-id={item.id}
                onClick={() => handleItemClick(item)}
                sx={{
                  py: 1.5,
                  px: 2,
                  backgroundColor: activeItem?.id === item.id ? '#f5f5f5' : 'transparent',
                  '&:hover': {
                    backgroundColor: '#f5f5f5',
                  },
                }}
              >
                <ListItemText
                  primary={item.name}
                  primaryTypographyProps={{
                    fontSize: '14px',
                    fontWeight: activeItem?.id === item.id ? 500 : 400,
                  }}
                />
                {item.items && item.items.length > 0 && (
                  <Typography sx={{ color: '#999', fontSize: '12px', ml: 1 }}>
                    ›
                  </Typography>
                )}
              </ListItem>
              <Divider sx={{ my: 0 }} />
            </Fragment>
          ))}
        </List>
      </Paper>

      {subMenuOpen && activeItem && activeItem.items.length > 0 && (
        <Paper
          sx={{
            borderRadius: '0 8px 8px 0',
            minWidth: '180px',
            overflow: 'auto',
            height: '265px',
            position: 'relative',
            left: '-1px',
          }}
        >
          <List dense sx={{ py: 0 }}>
            {activeItem.items.map((subItem) => (
              <Fragment key={subItem.id}>
                <ListItem
                  button
                  onClick={() => handleSubItemClick(subItem)}
                  sx={{
                    py: 1.5,
                    px: 2,
                    '&:hover': {
                      backgroundColor: '#f5f5f5',
                    },
                  }}
                >
                  <ListItemText
                    primary={subItem.name}
                    primaryTypographyProps={{
                      fontSize: '14px',
                    }}
                  />
                </ListItem>
                <Divider sx={{ my: 0 }} />
              </Fragment>
            ))}
          </List>
        </Paper>
      )}
    </Box>
  );

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-start',
        alignItems: 'center',
        flexWrap: 'wrap',
        margin: '5px',
        position: 'relative',
      }}
    >
      <FormControl sx={{ minWidth: '20%', width: '130px', marginRight: '5px' }}>
        <Select
          className="menu-trigger"
          open={false}
          onClick={handleClick}
          displayEmpty
          value=""
          IconComponent={() => null}
          renderValue={() => (
            <Typography
              sx={{
                textAlign: 'center',
                fontSize: !selected? '13px': '15px',
              }}
            >
              {selected || defText}
            </Typography>
          )}
          sx={{
            backgroundColor:'#ffffff',
            borderRadius: '10px',
            color: !selected? "gray": 'black',
            marginRight: '2px',
            height: '30px',
            cursor: 'pointer',
            border: '1px solid #078376',
            // Убираем стандартную обводку MUI (иначе будет двойная рамка)
            '& .MuiOutlinedInput-notchedOutline': {
              border: 'none',
            },
            // Если хотите сохранить рамку и при фокусе (такого же цвета)
            '&.Mui-focused': {
              border: '1px solid #078376',
            },
            '& .MuiSelect-select': {
              paddingLeft: '6px !important',
              paddingRight: '6px !important',
              textAlign: 'center',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              minHeight: 'auto !important',
            },
          }}
        />
      </FormControl>

      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        sx={{
          mt: 1,
          '& .MuiPopover-paper': {
            overflow: 'visible',
            backgroundColor: 'transparent',
            boxShadow: 'none',
          },
        }}
        disableScrollLock
      >
        <CombinedMenu />
      </Popover>
    </Box>
  );
}


export function SelectAdmin({user_id, w = "200px", h = "50px", onChange}) {

  const [data, setData] = useState([]);
  const [newAdmin, setNewAdmin] = useState(undefined);
  const [loading, setLoading] = useState(true);

  const { company_id } = useSelector(
    loginSelector
  );

  useEffect(() => {
      const fetchData = async () => {
  
          try {
            setLoading(true);
            let res = await get("Admins/getOnCompany", {cid:company_id})
            console.log("res0", res)
            res = res.filter((el) => el.id !== user_id)
            console.log("res1", res)
            setData(res)
          } catch (err) {
          } finally {
          setLoading(false);
          }
          
      };   
      
      fetchData();
    }, []); 

  if (loading) {
    return (<Loading></Loading>);
  }

  return (
    <Select
      displayEmpty
      value={newAdmin}
      onChange={(e) => {setNewAdmin(e.target.value); onChange(e.target.value)}}
      sx={{width: w, height: h}}
    >
      {data.map(el => {return <MenuItem key={el.id} value={el.id} style={{backgroundColor:el.color, borderRadius:'10px', marginBottom: '5px', /*width:'200px',*/}}>{el.fio}</MenuItem>})}
    </Select>
  )
}

export function CancelButton({action, text}) {
  return (
    <Button 
        onClick={action}    
        variant="text" 
        disableRipple
        disableFocusRipple
        sx={{
          height: "35px",
          textTransform: "none",
          fontSize: "18px",
          borderRadius: "10px",
          justifyContent: "flex-start",   // выравнивание текста по левому краю
          paddingLeft: 0,                 // убираем отступ слева, чтобы текст начинался с самого края
          "&:hover": {
            backgroundColor: "transparent", // фон не меняется
            color: buttonColorHover,          // подсветка текста (можно заменить на нужный цвет)
          },
          "&:active": {
            backgroundColor: "transparent",
          },
          "&:focus": {
            backgroundColor: "transparent",
          },
        }}
    >
        {text}
    </Button>
  )
}

export function OKButton({action, text, disabled=false}) {
  const preventDoubleClick = usePreventDoubleClick();
  return (
    <Button 
        onClick={preventDoubleClick(action, 1000)}    
        variant="contained" 
        disabled={disabled}
        sx={{ 
            height: "35px", 
            width: "150px", 
            textTransform: 'none',  
            fontSize: "18px",
            borderRadius: "10px"
        }}
    >
        {text}
    </Button>
  )
}

